import { render, staticRenderFns } from "./Facturation.vue?vue&type=template&id=659d178b&scoped=true"
import script from "./Facturation.vue?vue&type=script&lang=js"
export * from "./Facturation.vue?vue&type=script&lang=js"
import style0 from "./Facturation.vue?vue&type=style&index=0&id=659d178b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d178b",
  null
  
)

export default component.exports